import { UserSettingsPage as SharedUserSettingsPage } from '@iziping/ui';
import { SUPPORTED_LANGS } from '../../config/i18n/i18n';

interface UserSettingsPageProps {
    onClose?: () => void;
}

const UserSettingsPage: React.FC<UserSettingsPageProps> = ({ onClose }) => (
    <SharedUserSettingsPage langs={SUPPORTED_LANGS} onClose={onClose} />
);

export default UserSettingsPage;
